<template>
  <el-dialog
      :visible.sync="visible"
      :title="moduleName+'设置'"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
  >
    <el-form
        :model="dataForm"
        :rules="dataRule"
        ref="dataForm"
        @keyup.enter.native="dataFormSubmitHandle()"
        label-width="80px"
    >
      <el-form-item prop="dictName" :label="$t('dict.dictName')">
        <el-input
            v-model="dataForm.dictName"
            :placeholder="$t('dict.dictName')"
        ></el-input>
      </el-form-item>
      <el-form-item
          v-if="dataForm.pid === '0'"
          prop="dictType"
          :label="$t('dict.dictType')"
      >
        <el-input
            v-model="dataForm.dictType"
            :placeholder="$t('dict.dictType')"
        ></el-input>
      </el-form-item>
      <el-form-item prop="remark" :label="$t('dict.remark')">
        <el-input
            v-model="dataForm.remark"
            :placeholder="$t('dict.remark')"
        ></el-input>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{
          $t('confirm')
        }}
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'

export default {
  data () {
    return {
      visible: false,
      id: '',
      dataForm: {
        id: '',
        dictName: '',
        remark: '',
      },
    }
  },
  props: {
    pid: {
      type: String,
      default: ''
    },
    moduleName: '',
    dictType: ''
  },
  computed: {
    dataRule () {
      return {
        dictName: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur',
          },
        ]
      }
    },
  },
  methods: {
    reset () {
      this.dataForm = {
        id: '',
        dictName: '',
        remark: '',
      }
      this.$refs['dataForm'].resetFields()
    },
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.reset()
        if (this.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http
          .get(`/sys/dict/${this.id}`)
          .then(({ data: res }) => {
            if (res.code !== 0) {
              return this.$message.error(res.msg)
            }
            this.dataForm = {
              ...this.dataForm,
              ...res.data,
            }
          })
          .catch(() => {
          })
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
        function () {
          this.$refs['dataForm'].validate((valid) => {
            if (!valid) {
              return false
            }
            let postForm = {
              ...this.dataForm,
              dictValue: this.dataForm.dictName,
              dictType: this.dictType,
              pid: this.pid
            }
            this.$http[!this.id ? 'post' : 'put']('/sys/dict', postForm)
                .then(({ data: res }) => {
                  if (res.code !== 0) {
                    return this.$message.error(res.msg)
                  }
                  this.$message({
                    message: this.$t('prompt.success'),
                    type: 'success',
                    duration: 500,
                    onClose: () => {
                      this.visible = false
                      this.$emit('refreshDataList')
                    },
                  })
                })
                .catch(() => {
                })
          })
        },
        1000,
        { leading: true, trailing: false }
    ),
  },
}
</script>
